/**
 * Reaksiya kutubxonasi: sxema, tezlik/muvozanat funksiyalari, reyestr (pack'lardan).
 */
import type { ReactionDef } from './schema';

export * from './schema';
export * from './rate';

const REGISTRY = new Map<string, ReactionDef>();

export function registerReactions(list: readonly ReactionDef[]): void {
  for (const r of list) REGISTRY.set(r.id, r);
}

export function clearReactions(): void {
  REGISTRY.clear();
}

export function allReactions(): ReactionDef[] {
  return [...REGISTRY.values()];
}

export function getReaction(id: string): ReactionDef {
  const r = REGISTRY.get(id);
  if (!r) throw new Error(`Unknown reaction: ${id} (pack yuklanganmi?)`);
  return r;
}
